var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "domain-save-dialog" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            size: "mini",
            "label-width": "60px",
            "label-position": "left",
            onsubmit: "return false",
            rules: _vm.rules,
            "status-icon": "",
            model: _vm.form
          }
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "domain-name-input",
              attrs: { label: "组名称", prop: "name" }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.domainName,
                  callback: function($$v) {
                    _vm.domainName = $$v
                  },
                  expression: "domainName"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "domain-oper-button" },
            [
              _c(
                "el-button",
                {
                  staticClass: "save-button",
                  attrs: { type: "primary" },
                  on: { click: _vm.onSubmit }
                },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { staticClass: "cancel-button", on: { click: _vm.onCancel } },
                [_vm._v("取消")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f92db56", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f92db56","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Config/DomainSaveDialog.vue
// module id = null
// module chunks = 